// extracted by mini-css-extract-plugin
export default {"arrow_btns":"VerticalLongSection_arrow_btns__Gyv+U"};